module.exports = __webpack_public_path__ + "img/panneau_mobile10.85d1e84e.jpg";